class PermissionError extends Error {

  constructor(message) {
    super(message || '您沒有足夠的權限，請聯繫系統管理員')
  }

}

export default PermissionError



// WEBPACK FOOTER //
// ./src/errors/permission_error.js